import React, { Component } from 'react';
import GenericError from '../containers/Errors/GenericError';
import FullPageError from './FullPageError';
import { kibanaLog } from '../helpers/logger';
import { flagEnabled } from '../helpers/featureFlags';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { message } = error;
    const { componentStack } = errorInfo;

    kibanaLog('Error Boundary', { message, componentStack });
  }

  render() {
    const { hasError } = this.state;
    const { isHarness } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      if (flagEnabled('xmPaymentReskinEnabled')) {
        return (
          <FullPageError
            isErrorBoundary
            iconName="info"
            title="Something unexpected happened."
            subtitle="Try refreshing the page. If the problem persists, please check back later."
          />
        );
      }
      return (
        <GenericError isHarness={isHarness} isErrorBoundary />
      );
    }

    const { children } = this.props;

    return children;
  }
}
export default ErrorBoundary;
